/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $mobMenu = $('#mobile-overlay-menu');

        $('header button.navbar-toggle').click(function(){
          $mobMenu.toggle();
        });

        $mobMenu.find('.close').click(function(){
          $mobMenu.toggle();
        });

        // $('.open-pop').magnificPopup({
        //   items: {
        //       src: '<div class="popup">Dynamically created popup</div>',
        //       type: 'inline'
        //   }
        // });

        $('.open-pop').click(function(){
          console.log($(this).find('.popup-content').html());
          var content = $(this).parent().find('.popup-content').html();
          $.magnificPopup.open({
            items: {
                src: '<div class="popup">'+content+'</div>',
                type: 'inline'
            }
          });
        })

        helpers.wpcf7();



      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        setTimeout(function () {
          $('.page-loader .loader-inner').fadeOut(600, function(){
            $('.page-loader').fadeOut(600);
          });
        }, 300);

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $('.carousel-indicators li').click(function(){
          helpers.scrollToTop();
        })
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


// HELPERS functions
// -----------------------------------------------------------------------------
var helpers = (function($){

  var $win = $(window),
      $body = $('body');

  //export
  return {
    wpcf7: function(){
      //wpcf7
      $('.wpcf7-form').prepend($('div.wpcf7-response-output'));
    },
    scrollToTop : function(idSelector){
      var $id = $(idSelector);
      $('html,body').animate({scrollTop: 0},'slow');
    }
  };

})(jQuery);
